/**
 * @file 导航守卫-登录状态处理，忽略掉 App WebView
 */

import { i18n } from '@/locales/i18n';
import { getUserInfo } from '@/utils/userInfo';

export default [
    async ({ meta }, from, next) => {
        const userInfo = await getUserInfo();
        if (!window.sfe.prerender && !window.sfe.isApp && meta.needLogin && !userInfo) {
            // 跳转登录页
            const backurl = encodeURIComponent(window.location.href);
            const url = `/${i18n.global.locale.value || 'en'}/login/?redirect_url=${backurl}`;
            return window.location.assign(url);
        }
        return next();
    },
];
